<template lang="pug">
  .mcl-wrapper
    .input-group
      input.search-input(type="text", :placeholder="filterText", v-model="search", @focus="$event.target.select()", ref="searchInput")
      span.input-group-addon.glyphicon.glyphicon-filter
    .mcl-items(v-when-scroll-ends="{callback: loadMore}")
      .checkbox.text-left(v-if="allowSelectAll && !disabled")
        label.to-click
          input(type="checkbox" v-model="selectVisible", ref="searchInput")
          span.noselect Selecionar todos visíveis

      span(v-if="displayedData")
        template(v-if="useState")
          .checkbox.text-left(v-for="item in displayedData")
            MultiItemSelector(:useState="useState", :item="item", :uniqueKey="uniqueKey", :disabled="disabled")

        template(v-else="")
          .checkbox.text-left(v-for="item in displayedData")
            MultiItemSelector(v-model="value" @change="_setState", :item="item", :uniqueKey="uniqueKey", :disabled="disabled")

      div(v-if="loading")
        .loading-bars(v-for="i in [1, 2, 3, 4, 5]" v-bind:style="{'width': Math.random() * (70 - 35) + 35 + '%'}") &nbsp;

</template>

<script>
import ClickOutside from 'vue-click-outside'
import MultiItemSelector from './MultiItemSelector.vue'
import virtualList from 'vue-virtual-scroll-list'
import SelectorPW, { SelectorItem } from '../HelpersPW/SelectorPW.vue'
import { base } from './mixins'

export default {
  mixins: [base()],
  computed: {
    popUpMinWidth () { return this.$refs.selectbox.clientWidth + 'px' },
    displayedData () { return this.state.loaded },
    loading () { return this.state.loading },
    currentPage () {
      return this.state.currentPage !== undefined ? this.state.currentPage : 0
    },
    totalPages () { return this.state.totalPages },
    search: {
      get () { return this.state.search },
      set (search) {
        this.state = {search: search, loaded: []}
        this.loadItems(0, search)
      }
    }
  },
  components: { MultiItemSelector, virtualList, SelectorPW, SelectorItem },
  directives: { ClickOutside }
}
</script>

<style>
.mcl-items {
  font-size: 14px;
  overflow-y: scroll;
}
.item-fixed-height {
  height: 22px;
}
</style>

<style scoped>
.mcl-wrapper {
  border: 1px solid #dadada;
  border-radius: 3px;
  background-color: white;
}

.mcl-items {
  min-height: 150px;
  max-height: 150px;
  overflow-y: scroll;
}

.search-input {
  width:100%;
  /* border-radius: 5px; */
  background: #fff;
  border: 1px solid #ccc;
  outline:none;
  padding: 6px;
}

.search-input:focus{
  border:1px solid #56b4ef;
  box-shadow: 0px 0px 3px 1px #c8def0;
}

label { margin-left: 10px; }
.loading-bars {
  background-color: whitesmoke;
  height: 17px;
  margin: 8px;
  margin-left: 10px;
}
.pop-up-size {
  width: 65%;
  overflow: hidden !important;
  position: absolute !important;
  margin-top: 30px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
.checkbox.text-left {
  width: 100%;
}
</style>
